import { Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';
import { EmptyResponse, IAccountService, VerificationId } from '../../common-react/core';
import { Inject, Injectable, InjectionToken } from '../../common-react/injection';
import { tryGetValue } from '../../common-react/utils';

import { UserProfile } from '../data/user-profile.do';

import { IUserProfileService } from './user-profile.service';

export interface ICurrentAccountVerificationService {
  requestEmailVerification(): Observable<EmptyResponse>;
  requestPhoneNumberVerificationToken(): Observable<VerificationId>;
  hasPendingVerification(): Observable<boolean>;
}

export const ICurrentAccountVerificationService
  = new InjectionToken<ICurrentAccountVerificationService>('ICurrentAccountVerificationService');

@Injectable()
export class CurrentAccountVerificationService implements ICurrentAccountVerificationService {

  constructor(
    @Inject(IAccountService)
    private accountService: IAccountService,
    @Inject(IUserProfileService)
    private userProfileService: IUserProfileService,
  ) {
  }

  public requestEmailVerification(): Observable<EmptyResponse> {
    return this.userProfileService.getUserProfile().pipe( mergeMap(
      (userProfile: UserProfile) => {
        const email: string = tryGetValue(userProfile, 'email', '') as string;
        return this.accountService.requestEmailVerification(email);
      }
    ));
  }

  public requestPhoneNumberVerificationToken(): Observable<VerificationId> {
    return this.userProfileService.getUserProfile().pipe( mergeMap(
      (userProfile: UserProfile) => {
        const phoneNumber: string = tryGetValue(userProfile, 'phoneNumber', '') as string;
        return this.accountService.requestPhoneNumberVerificationToken(phoneNumber);
      }
    ));
  }

  public hasPendingVerification(): Observable<boolean> {
    return this.userProfileService.getUserProfile().pipe(map((userProfile: UserProfile) => {
      return userProfile.hasPendingVerification();
    }));
  }
}
